import {SavedSearchInfo, SavedSearchType, TableSavedSearch} from '../typedef';

import {createBaseTableSearch} from './create-base-table-search';
import {getSearchTypeSpecificData} from './get-search-type-specific-data';

type DataSectionItem = {
    savedSearchInfo: SavedSearchInfo,
    totalCount?: number,
};

export const transformItemToTableSearch = (
    item: DataSectionItem,
    savedSearchType: SavedSearchType,
    getTypeDescription: (code: string | undefined) => string,
): TableSavedSearch => {
    const rawCode = item.savedSearchInfo.searchType;
    const base = createBaseTableSearch(item);
    const typeSpecificData = getSearchTypeSpecificData(rawCode, savedSearchType, getTypeDescription);

    return {...base, ...typeSpecificData};
};
